export const FOCUSED_INBOX_REQUEST_BASE_URL = 'FocusedInboxB2/api/v1/Nudges';
